export default __webpack_public_path__ + "images/e1ebb4323d556da421e5d7e0d8b1f9f3-pharma-logo.svg";